import React from 'react'

const CosmeticsCard = ({data, style}: any) => {
  return (
    <div className={`bg-blue-20 rounded-[12px] w-full min-w-[230px] w-[256px] w-full lg:!w-full 2xl:!w-full h-[140px] min-h-[140px] h-full sm:w-full relative ${style}`}>
        <div className='p-[24px]'>
            <h3 className='text-[16px] leading-[24px] font-semibold font-demi'>{data.text1.toUpperCase()}</h3>
            <h3 className='text-[16px] leading-[24px] font-semibold font-demi'>{data.text2.toUpperCase()}</h3>
            <h3 className='text-[16px] leading-[24px] font-semibold font-demi'>{data.text3.toUpperCase()}</h3>
        </div>
        <div>
            <img
                src={data.img}
                alt={data.text1}
                className='absolute bottom-0 right-0 rounded-[12px]'
            />
        </div>
    </div>
  )
}

export default CosmeticsCard